import {Model, l10n} from 'MWC';

const timeUnit = 'time_unit';
const CREDIT_SUM = 300000;

export default class extends Model {
    static fields;

    constructor(data, list, mode) {
        super();

        this.data = data;
        this.list = list;
        this.currentName = mode;
        this._initVariables(data);
        this._initFields(this.current);
    }

    _initVariables(data) {
        this.current = data[this.currentName];
        this.creditSum = CREDIT_SUM;
        this.loanTerm = 12;
        this.mounthCommission = this.current.month_commission;
        this.oneTimeComission = this.current.one_time_commission;
        this.requiredPayment = 0;
        this.overpayment = 0;
        this.rate = 0;
    }

    _initFields(data) {
        this.fields = {
            ...data
        };
    }

    changeField(name, value) {
        this[name] = value;
        if (name === 'currentName') {
            this._initVariables(this.data);
            this._initFields(this.current);
        }

        this.calculateIndicators();
    }

    calcRequiredPayment() {
        const creditSum = this.getCreditSum() + this.getCreditSum() * this.getOneTimeCommission(),
            creditTerm = this.getCurrentTerm(),
            monthCommission = this.getMonthCommission() / 100,
            rate = (this.getCreditRate() / 12 / 100).toFixed(4),
            middleDay = 365 / 360,
            numerator = (creditSum * rate * 365) / 360,
            denominator = 1 - Math.pow(1 + rate * middleDay, -creditTerm);

        return numerator / denominator + creditSum * monthCommission;
    }

    calculateIndicators() {
        this.rate = this.rateCalculate();
        this.requiredPayment = this.calcRequiredPayment();
        this.overpayment = this.findOverpayment();
    }

    findOverpayment() {
        const requiredPayment = this.getRequiredPayment(),
            term = this.getCurrentTerm(),
            creditSum = this.getCreditSum();

        return requiredPayment * term - creditSum;
    }

    rateCalculate() {
        return this.current.real_rate[this.getTerms().indexOf(parseInt(this.loanTerm))];
    }

    getCreditSum() {
        return +this.creditSum;
    }

    getMinSumEdge() {
        return +this.current.min;
    }

    getSumStep() {
        return +this.fields.step;
    }

    getMaxSumEdge() {
        return +this.current.max;
    }

    getTerms() {
        return this.current.terms;
    }

    getMinTermEdge() {
        return this.current.terms[0];
    }

    getMaxTermEdge() {
        return this.current.terms[this.current.terms.length - 1];
    }

    getCurrentTerm() {
        return this.loanTerm;
    }

    getCreditTerm() {
        return +this.getTerms()[this.getCurrentTerm()];
    }

    getCreditRate() {
        return this.rate;
    }

    getMonthCommission() {
        return this.mounthCommission;
    }

    getOneTimeCommission() {
        return this.oneTimeComission;
    }

    getRequiredPayment() {
        return this.requiredPayment;
    }

    getOverpayment() {
        return this.overpayment;
    }

    getListOfCredits() {
        return this.list;
    }

    getCurrentCredit() {
        return this.currentName;
    }
}
